<template>
  <es-layout
    custom-class
    layout="{{ isCallbackPage ? ['footer'] : ['header', 'footer']}}"
    navbarTitle="{{title}}"
    navbarStyle="{{navbarStyle}}"
    leftArrow="{{true}}"
  >
    <search-input placeholder="{{title}}" bindinput="searchCity" bind:clear="close" />
    <view wx:if="{{canRenderList}}" class="es-city-container">
      <!--  城市列表  -->
      <city-scroll-list
        wx:if="{{(allCities.length || allHotCities.length) && !isShowSearchResult}}"
        list="{{allCities}}"
        bindhandle="updateCity"
        showAnchorFloat
        showSingleCity
      >
        <city-label
          wx:if="{{allHotCities.length !== 0}}"
          list="{{allHotCities}}"
          title="热门城市"
          bindhandle="updateCity"
        />
      </city-scroll-list>
      <blank-page
        wx:if="{{!allCities.length && !isShowSearchResult}}"
        blankImageUrl="{{blankImageUrl}}"
        blankContextTitle="{{blankContextTitle}}"
        blankContextSubTitle="{{blankContextSubTitle}}"
        hasButton="{{hasButton}}"
        blankPageType="blank-page"
        bind:click-button="clickButton"
      />
      <!--  搜索页面  -->
      <scroll-view
        scroll-y="{{true}}"
        wx:style="{{ {  height: '100%', scrollBehavior: 'smooth'} }}"
        scroll-with-animation
      >
        <city-search
          wx:if="{{searchList.length && isShowSearchResult}}"
          list="{{searchList}}"
          label="{{searchListLabel}}"
          type="station_list"
          labelType="name"
          bindhandle="updateCity"
          bindrefresh="citySearchRefresh"
        />
        <blank-page
          wx:if="{{!searchList.length && isShowSearchResult}}"
          blankImageUrl="{{blankImageUrlSearch}}"
          blankContextTitle="{{blankContextTitleSearch}}"
          blankContextSubTitle="{{blankContextSubTitleSearch}}"
          hasButton="{{hasButtonSearch}}"
          blankPageType="blank-page"
          bind:click-button="clickButtonSearch"
        />
      </scroll-view>
    </view>
    <choosed-city
      wx:if="{{selectType === 'mutiple'}}"
      slot="footer"
      citys="{{choosedCitys}}"
      bindcancel="onCancel"
      binddelete="onDelete"
      bindconfirm="updateMutipleCityConfirm"
    />
  </es-layout>
</template>

<style lang="stylus" scoped>
  .es-city-container
    height calc(100% - 45px)
    background #ffffff
</style>

<script>
  import { createPage, mpx } from '@didi/es-mpx-creator'
  import store from '@/store'
  import { getStorage, setStorage } from '@/utils/storage'
  import { LOAD_FAIL_CONTENT } from '@/common/constant'
  import {
    STORAGE_EDIT_CITY_TYPE,
    STORAGE_EDIT_CITY_INFO_FOR_ALIWEB,
  } from '@/utils/train-storage'
  import { innerRouter, pagePath } from "@/common/jump";
  import { trackEvent } from '@/common/track'
  import { 
    is,
    bridge,
    query as webxQuery,
    hashQuery
  } from '@didi/webx-js'
  import webviewBridge from '@mpxjs/webview-bridge'

  const { navigateBack, postMessage } = webviewBridge
  const query = () => {
    return {
      ...webxQuery(),
      ...hashQuery(),
    }
  }

  createPage({
    data: {
      navbarStyle: {
        background: '#ffffff',
        'font-size': '18px',
        'font-weight': 600,
        color: '#000000'
      },
      isShowSearchResult: false,
      // location: {},
      blankImageUrl: null,
      blankContextTitle: '',
      blankContextSubTitle: '',
      hasButton: false,
      blankImageUrlSearch: null,
      blankContextTitleSearch: '',
      blankContextSubTitleSearch: '',
      hasButtonSearch: false,
      searchKey: '',
      pageFrom: '',
      selectType: 'single',
      maxChoosedCitysLength: 3,
      choosedCitys: [],
      canRenderList: false,
    },
    computed: {
      ...store.mapState({
        trainCities: 'travel.trainCities', // 城市列表
        trainHotCities: 'travel.trainHotCities', // 热门城市列表
        flightsCities: 'flights.flightsCities',
        flightsHotCities: 'flights.flightsHotCities',
        trainSearchRetList: 'travel.searchedCityList', // 搜索城市结果列表
      }),
      ...store.mapGetters({
        flightsSearchRetList: 'flights.searchRetList',
        selectCitys: 'flights.selectCitys',
      }),
      allCities() {
        return this.pageFrom === 'flights' ? this.flightsCities : this.trainCities
      },
      allHotCities() {
        const _allHotCitys = this.pageFrom === 'flights' ? this.flightsHotCities : this.trainHotCities
        const _choosedCitysMap = this.choosedCitys.reduce((a, b) => {
          a[b.city_id] = true
          return a
        }, {})
        return _allHotCitys.map(i => ({
          ...i,
          isChoosed: _choosedCitysMap[i.city_id]
        }))
      },
      travelType() {
        if(this.isCallbackPage) {
          return query().travelType === 'fromCity' ? 'from' : 'to'
        }
        if(this.pageFrom === 'flights') {
          return query().type // from to
        }else {
          return getStorage(STORAGE_EDIT_CITY_TYPE) === 'currentToCity' ? 'to' : 'from'
        }
      },
      title() {
        return this.travelType === 'to' ? '选择目的地' : '选择出发地'
      },
      searchListLabel() {
        return this.pageFrom === 'flights' ? '机场' : '火车站'
      },
      searchList() {
        if(this.pageFrom === 'flights') {
          return this.flightsSearchRetList
        }else {
          return this.trainSearchRetList
        }
      },
      isCallbackPage() {
        return query().as_cb_page === '1'
      }
    },
    methods: {
      ...store.mapActions({
        getFlightsCityList: 'flights.getFlightsCityList',
        getFlightsCityListByKeyword: 'flights.getFlightsCityListByKeyword',
        getTrainCityList: 'travel.getTrainCityList',
        getTrainCityListByKeyword: 'travel.getTrainCityListByKeyword',
      }),
      ...store.mapMutations({
        changeSelectCityList: 'travel.changeSelectCityList',
        setFlightsQuery: 'flights.setFlightsQuery',
      }),
      onCancel() {
        if(this.isCallbackPage) {
          if(is('passenger')) {
            bridge.closePage()
          }else if(is('miniprogram')) {
            navigateBack()
          }
          return
        }
        innerRouter.goback()
      },
      onDelete({ detail }) {
        this.updateChoosedCitys(detail)
      },
      updateChoosedCitys({ city_id, city_name }) {
        const _targetIdx = this.choosedCitys.findIndex(item => item.city_id === city_id)
        if(_targetIdx > -1) {
          this.choosedCitys.splice(_targetIdx, 1)
        }else if(this.choosedCitys.length >= this.maxChoosedCitysLength) {
          mpx.showToast({
            title: '最多可选3个城市',
            icon: 'none'
          })
        }else {
          this.choosedCitys.push({
            city_id,
            city_name,
            name: city_name,
            id: city_id,
          })
        }
      },
      callBackPageHandle(type, params) {
        if(is('passenger')) {
          bridge.callHandler('setResultData', {
            type,
            data: params
          })
          bridge.closePage()
        }else if(is('miniprogram')) {
          postMessage({
            data: {
              type: 'yks-city',
              result: {
                type,
                data: params
              },
            },
            success (res) {
              console.log('postmessage成功回调, 结果：', res)
            }
          })
          navigateBack()
        }
      },
      updateCity({ detail }) {
        if(this.selectType === 'mutiple') {
          this.updateChoosedCitys(detail)
          return
        }
 				const { __aliwebview } = this.$mpxRoute.query
        const { city_id, city_name, name, id, type } = detail
        if(this.pageFrom === 'train') {
          if(this.isCallbackPage) {
            this.callBackPageHandle('single', {
              city_id,
              city_name,
              name: name || city_name,
            })
            return
          }
          const city = {
            id: city_id,
            name: name || city_name,
            precise_search: '0',
            subName: city_name
          }
          if(!getStorage(STORAGE_EDIT_CITY_TYPE) || !city_id) return
          const params = { type: getStorage(STORAGE_EDIT_CITY_TYPE), data: city }
          this.changeSelectCityList(params)
          __aliwebview && setStorage({
            key: STORAGE_EDIT_CITY_INFO_FOR_ALIWEB,
            data:params
          })
        }else if(this.pageFrom === 'flights') {
          if(this.isCallbackPage) {
            this.callBackPageHandle('single', {
              city_id,
              city_name,
              name: name || city_name,
              id: id || city_id,
              type: type || 0,
            })
            return
          }
          const _city = [{
            city_id,
            city_name,
            name: name || city_name,
            id: id || city_id,
            type: type || 0, // 0国内城市 2国内机场
          }]
          const _query = this.travelType === 'to'
            ? { toCitys: _city }
            : { fromCitys: _city }
          this.setFlightsQuery(_query)
        }
        innerRouter.goback()
      },
      updateMutipleCityConfirm() {
        if(!this.choosedCitys.length) {
          mpx.showToast({
            title: '至少选择一个城市',
            icon: 'none'
          })
          return
        }
        if(this.isCallbackPage) {
          this.callBackPageHandle('mutiple', this.choosedCitys)
          return
        }
        const _query = this.travelType === 'to'
          ? { spToCitys: this.choosedCitys }
          : { spFromCitys: this.choosedCitys }
        this.setFlightsQuery(_query)
        innerRouter.goback()
      },
      /**
       * @description: 搜索
       */
      searchCity({ detail }) {
        this.searchKey = detail
        this.getCityListByKeyword()
      },

      /**
       * @description: 清空
       */
      close() {
        this.searchKey = ''
        this.isShowSearchResult = false
      },
      getTrainCityListFunc() {
        this.getTrainCityList().then((res) => {
          const { code, data, message, success } = res || {}
          if (success) {
            if (code === '0' && data?.cities?.length) {
              this.blankImageUrl = null
              this.blankContextTitle = ''
              this.blankContextSubTitle = ''
              this.hasButton = false
            } else {
              this.blankImageUrl =
                'https://pt-starimg.didistatic.com/static/starimg/img/Ot7ziDz0Oc1645096142894.png' // 空数据
              this.blankContextTitle = '未找到符合条件的结果'
              this.blankContextSubTitle = '请更改站点重新查询'
              this.hasButton = false
            }
          } else {
            this.blankImageUrl =
              'https://pt-starimg.didistatic.com/static/starimg/img/YMkvZdbImg1644496134866.png'
            this.blankContextTitle = '加载失败'
            this.blankContextSubTitle = LOAD_FAIL_CONTENT
            this.hasButton = true
            return mpx.showToast({
              title: '站点查询失败',
              icon: 'error'
            })
          }
        })
      },
      getFlightsCityListFunc() {
        this.getFlightsCityList().then(ret => {
          this.blankImageUrl = ret ? null : 'https://pt-starimg.didistatic.com/static/starimg/img/Ot7ziDz0Oc1645096142894.png'
          this.blankContextTitle = ret ? '' : '未找到符合条件的结果'
          this.blankContextSubTitle = ret ? '' : '请重新查询'
          this.hasButton = false
        })
      },
      clickButton() {
        this.refreshCityList()
      },
      getFlightsCityListByKeywordFunc(query) {
        this.getFlightsCityListByKeyword(query).then(ret => {
          this.blankImageUrlSearch = ret ? null : 'https://pt-starimg.didistatic.com/static/starimg/img/Ot7ziDz0Oc1645096142894.png'
          this.blankContextTitleSearch = ret ? '' : '未找到符合条件的结果'
          this.blankContextSubTitleSearch = ret ? '' : '请重新查询'
          this.hasButtonSearch = false
        })
      },
      getTrainCityListByKeywordFunc(query) {
        this.getTrainCityListByKeyword(query).then((res) => {
          const { code, data, message, success } = res || {}
          if (success) {
            if (code === '0' && data?.stations?.length) {
              this.blankImageUrlSearch = null
              this.blankContextTitleSearch = ''
              this.blankContextSubTitleSearch = ''
              this.hasButtonSearch = false
            } else {
              this.blankImageUrlSearch =
                'https://pt-starimg.didistatic.com/static/starimg/img/Ot7ziDz0Oc1645096142894.png' // 空数据
              this.blankContextTitleSearch = '未找到符合条件的结果'
              this.blankContextSubTitleSearch = '请更改站点重新查询'
              this.hasButtonSearch = false
            }
          } else {
            this.blankImageUrlSearch =
              'https://pt-starimg.didistatic.com/static/starimg/img/YMkvZdbImg1644496134866.png'
            this.blankContextTitleSearch = '加载失败'
            this.blankContextSubTitleSearch = LOAD_FAIL_CONTENT
            this.hasButtonSearch = true
            return mpx.showToast({
              title: '站点查询失败',
              icon: 'error'
            })
          }
        })
      },
      clickButtonSearch() {
        this.getCityListByKeyword()
      },
      citySearchRefresh() {
        /**
         * 搜索城市点击点击 展开/折叠 按钮后，需要强制刷新
         * 不然会出现scroll-view无法滚动的情况
         */
        this.$forceUpdate()
      },
      getCityListByKeyword() {
        const query = { keyword: this.searchKey }
        this.isShowSearchResult = true
        if(this.pageFrom === 'train') {
          this.getTrainCityListByKeywordFunc(query)
        }else if(this.pageFrom === 'flights') {
          this.getFlightsCityListByKeywordFunc(query)
        }
      },
      refreshCityList() {
        const {
          pageFrom='train',
          selectType='single',
        } = query()
        this.pageFrom = pageFrom
        this.selectType = selectType
        if(pageFrom === 'train') {
          this.getTrainCityListFunc()
        }else if(pageFrom === 'flights') {
          this.getFlightsCityListFunc()
        }
      },
      initMutiplePageData() {
        if(this.isCallbackPage) {
          const _choosedCitys = query().choosedCitys
          this.choosedCitys = _choosedCitys ? JSON.parse(_choosedCitys) : []
          return
        }
        if(this.pageFrom === 'flights') {
          const { spFromCitys, spToCitys } = this.selectCitys
          this.choosedCitys = this.travelType === 'to'
            ? spToCitys
            : spFromCitys
        }
      },
      setTitle() {
        document.title = this.title
        if(is('passenger')) {
          bridge.setTitle({
            title: this.title
          })
          bridge.updateNaviView({
            shadowhidden: 1,
          })
        }
      }
    },
    created() {
      this.isCallbackPage && this.setTitle()
      this.refreshCityList()
      if(this.selectType === 'mutiple') {
        this.initMutiplePageData()
      }
    },
    mounted() {
      // 页面未加载直接渲染list列表过大会有卡顿体验
      this.canRenderList = true
    }
  })
</script>

<script name="json">
  module.exports = {
    usingComponents: {
      'city-label': './components/city-label',
      'city-search': './components/city-search',
      'search-input': './components/search-input',
      'choosed-city': './components/choosed-city',
      'blank-page': '@/es-mpx-ui/lib/blank-page',
      'city-scroll-list': './components/city-scroll-list'
    }
  }
</script>
